import "regenerator-runtime/runtime";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

const connector = new AppSearchAPIConnector({
  searchKey: "search-1gvrkpfv9a9px3z2w14jp4k3",
  engineName: "meta-engine-contacts",
  endpointBase: "https://murdoch-university.ent.australiaeast.azure.elastic-cloud.com",
  cacheResponses: false
});

const config = {
  debug: true,
  apiConnector: connector,
  searchQuery: {
    disjunctiveFacets: ["facet_label"],
    facets: {
      facet_label: {
        type: "value"
      }
    }
  },
  autocompleteQuery: {
    // performs a prefix search on the query
    results: {
      resultsPerPage: 5, // number of results to display. Default is 5.
      result_fields: {
        // Add snippet highlighting within autocomplete suggestions
        title: { snippet: { size: 100, fallback: true } }
      }
    },
    // performs a query to suggest for values that partially match the incomplete query
    suggestions: {
      types: {
        // Limit query to only suggest based on "title" field
        documents: { fields: ["title"] }
      },
      // Limit the number of suggestions returned from the server
      size: 4
    }
  }
};

export default config;
